import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

import { BaseFormKitComponent } from '../base/base-form-kit.component';
import { SizeType } from './models/size.type';
@Component({
    selector: 'toggle-switch',
    imports: [
        CommonModule,
        TranslateModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    styleUrls: ['../base/base-form-kit.scss'],
    templateUrl: './toggle-switch.component.html'
})
export class ToggleSwitchComponent extends BaseFormKitComponent {
  //#region properties

  @Input() name: string = '';
  @Input() size: SizeType = 'sm';
  @Input() bgColorClass: string = 'fk-bg-primary-500';

  id: string = '';

  //#endregion

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.onEmitValue();
    this.checkAppDirectionByHtmlDirection();
    try {
      this.id = this.name + '-' + Math.random().toString(16).slice(2);
    } catch (error) {
      console.error('ToggleSwitch Error => ', error);
    }
  }

  onEmitValue() {
    if (!this.value) this.value = false;
    this.valueChange.emit(this.value);
  }
}
